<template>
  <div class="box">
    <el-card class="topCard">
      <span>需求响应</span>
      <div class="btns">
        <el-button @click="handelChangeMok(1)" :class="{ active: num === 1 }">
          业务申请
        </el-button>
        <span>|</span>
        <el-button @click="handelChangeMok(2)" :class="{ active: num === 2 }">
          业务分发
        </el-button>
        <span>|</span>
        <el-button @click="handelChangeMok(3)" :class="{ active: num === 3 }">
          业务结算
        </el-button>
      </div>
    </el-card>
    <div> 
      <apply v-if="num === 1"></apply>
      <fenfa v-if="num === 2"></fenfa>
      <jiesuan v-if="num === 3"></jiesuan>
    </div>
  </div>
</template>

<script>
import apply from "./apply/index.vue";
import fenfa from "./fenfa/index.vue";
import jiesuan from "./jiesuan/index.vue";
export default {
  name: "demandResponse",
  components: { apply, fenfa, jiesuan },
  data() {
    return {
      num:1,
    };
  },
  methods:{
    handelChangeMok(index){
      this.num = index
    }
  }
};
</script>

<style lang="scss" scoped>
.box{
  width: 100%;
  max-width: 1872px;
  margin: 0 auto;
}
.topCard {
    height: 64px;
    font-size: 18px;
    font-weight: 600;
    margin: 20px 0;

    span {
      color: #068667 !important;
    }

    .btns {
      float: right;
      position: relative;
      top: -6px;
      >span{
        color: #D3D9D7;
        font-size: 12px;
      }

      .el-button {
        margin: 0 10px;
        background: #fff;
        color: #8B9996;
      }

      .active {
        background: #068d6c;
        color: #fff;
      }
    }
  }
</style>
